/* ====================================================================
   SOLO-BESTELLREGEL — Vorabsperre im Browser
   ====================================================================

   Konfiguration und die massgebliche Pruefung stehen serverseitig in
   snippets/t12-solo-config.liquid. Diese Datei sorgt nur dafuer, dass der
   Kunde gar nicht erst in den falschen Zustand geraet und den Grund an der
   Stelle liest, an der er geklickt hat.

   WAS SIE ABDECKT
     - Kaufformular auf der Produktseite
     - Sofort-Kauf auf Produktkacheln, auch nachgeladene
     - Empfehlungsbloecke, die ihre Formulare spaeter einhaengen
     - Warenkorb: Hinweis ueber dem Kasse-Knopf und Kasse gesperrt

   WAS SIE NICHT ABDECKT, bewusst und dokumentiert
     - Warenkorb-Permalinks der Form /cart/<id>:1,<id>:1 gehen per Weiterleitung
       direkt in den Checkout, es wird nie eine Theme-Seite gerendert
     - Die Storefront-API, deren Token oeffentlich im Markup steht
     - Alle Verkaufskanaele ausser dem Online-Shop, die das Theme nicht laden
     - Abgeschaltetes JavaScript beim Hinzufuegen; im Warenkorb greift dann
       aber die serverseitige Pruefung, sobald diese Datei geladen wird
   Das ist eine Bremse fuer den normalen Kunden, kein Riegel gegen Absicht.
   ==================================================================== */
(function () {
  'use strict';

  var wurzel = document.getElementById('t12-solo-config');
  if (!wurzel) return;

  var cfg;
  try { cfg = JSON.parse(wurzel.textContent); } catch (e) { return; }
  if (!cfg || !Array.isArray(cfg.solo) || cfg.solo.length === 0) return;

  var SOLO = cfg.solo.map(Number);
  var FREI = (cfg.begleiter || []).map(Number);
  var basis = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var istSolo = function (id) { return SOLO.indexOf(Number(id)) !== -1; };
  var istFrei = function (id) { return FREI.indexOf(Number(id)) !== -1; };

  /* Zuletzt bekannter Warenkorbstand. Wird nach jeder Aenderung neu geholt.
     Ein Submit-Handler kann nicht synchron warten, deshalb der Zwischenstand;
     der fetch-Weg unten prueft zusaetzlich immer frisch. */
  var stand = null;

  function ladeStand() {
    return fetch(basis + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { stand = c; return c; })
      .catch(function () { return null; });
  }

  function konflikt(cart, neueId) {
    if (!cart || !cart.items) return false;
    if (istFrei(neueId)) return false;

    var hatSolo = false, hatFremd = false;
    cart.items.forEach(function (z) {
      var id = Number(z.variant_id);
      if (istSolo(id)) hatSolo = true;
      else if (!istFrei(id)) hatFremd = true;
    });

    return istSolo(neueId) ? hatFremd : hatSolo;
  }

  function kasten(inhalt, klasse) {
    var d = document.createElement('div');
    d.className = 't12-solo ' + (klasse || '');
    d.setAttribute('role', 'status');
    d.innerHTML =
      '<span class="t12-solo__punkt" aria-hidden="true"></span>' +
      '<p class="t12-solo__text"><strong></strong> <span></span></p>';
    d.querySelector('strong').textContent = inhalt.titel;
    d.querySelector('span:last-child').textContent = inhalt.text;
    return d;
  }

  /* Meldung dort zeigen, wo geklickt wurde. Kein Alert, kein Modal, und
     nichts, was von selbst wieder verschwindet: wer sie uebersieht, klickt
     erneut und versteht dann nicht, warum nichts passiert. */
  function melde(naheBei) {
    var ziel = naheBei && naheBei.closest ? naheBei.closest('form') || naheBei : null;
    var vorhanden = ziel && ziel.parentNode
      ? ziel.parentNode.querySelector(':scope > .t12-solo--sperre') : null;

    /* Steht die Meldung schon da, wird sie erneut hervorgehoben. Sonst klickt
       der Kunde ein zweites Mal, sieht keinerlei Reaktion und schliesst daraus,
       der Knopf sei defekt. */
    if (vorhanden) {
      vorhanden.classList.remove('t12-solo--merken');
      void vorhanden.offsetWidth;
      vorhanden.classList.add('t12-solo--merken');
      vorhanden.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      return;
    }

    var box = kasten(cfg.sperre, 't12-solo--sperre');
    if (ziel && ziel.parentNode) ziel.parentNode.insertBefore(box, ziel.nextSibling);
    else document.body.appendChild(box);
    box.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }

  function idsAus(body) {
    var ids = [];
    try {
      if (!body) return ids;
      if (typeof body === 'string') {
        var j = JSON.parse(body);
        if (j.id) ids.push(j.id);
        if (Array.isArray(j.items)) j.items.forEach(function (i) { if (i.id) ids.push(i.id); });
      } else if (body instanceof FormData) {
        var v = body.get('id');
        if (v) ids.push(v);
      } else if (body instanceof URLSearchParams) {
        var u = body.get('id');
        if (u) ids.push(u);
      }
    } catch (e) { /* unbekanntes Format: nicht blockieren */ }
    return ids.map(Number).filter(function (n) { return !isNaN(n); });
  }

  /* ---- 1. fetch abfangen. Der Hauptweg dieses Themes. ---------------- */
  var echtesFetch = window.fetch;
  window.fetch = function (eingabe, init) {
    var url = typeof eingabe === 'string' ? eingabe : (eingabe && eingabe.url) || '';
    if (!/\/cart\/(add|update)(\.js)?/.test(url)) {
      return echtesFetch.apply(this, arguments);
    }

    var ids = idsAus(init && init.body);
    if (!ids.length) {
      return echtesFetch.apply(this, arguments).then(function (r) { ladeStand(); return r; });
    }

    var selbst = this;
    var args = arguments;
    return ladeStand().then(function (cart) {
      var stoert = ids.some(function (id) { return konflikt(cart, id); });
      if (!stoert) {
        return echtesFetch.apply(selbst, args).then(function (r) { ladeStand(); return r; });
      }
      melde(document.activeElement);
      return Promise.reject(new Error('T12: Solo-Regel, Hinzufuegen abgelehnt.'));
    });
  };

  /* ---- 2. Submit in der Capture-Phase. Faengt auch Formulare, die
            spaeter eingehaengt werden, und laeuft vor dem Theme. -------- */
  document.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;

    var feld = form.querySelector('[name="id"]');
    if (!feld || !feld.value) return;
    if (!konflikt(stand, feld.value)) return;

    ev.preventDefault();
    ev.stopImmediatePropagation();
    melde(form);
  }, true);

  /* ---- 3. Warenkorb: Hinweis setzen, Kasse sperren ------------------- */
  function warenkorbSperren() {
    if (!cfg.konflikt) return;

    document.querySelectorAll('form[action$="/cart"], form[action*="/cart?"]').forEach(function (form) {
      if (!form.querySelector('[name="checkout"]')) return;
      if (form.previousElementSibling &&
          form.previousElementSibling.classList.contains('t12-solo--warenkorb')) return;

      form.parentNode.insertBefore(kasten(cfg.warenkorb, 't12-solo--warenkorb'), form);

      /* Der Knopf bleibt sichtbar und beschriftet. Ein ausgegrauter Knopf
         ohne Erklaerung liest sich als Fehler des Shops. */
      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        ev.stopImmediatePropagation();
        var box = form.parentNode.querySelector('.t12-solo--warenkorb');
        if (box) box.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }, true);
    });
  }

  /* ---- 4. Produktseite des Solo-Buchs: Hinweis VOR dem Kauf ---------
          Die meisten Kunden sehen nur diesen einen Text. Er steht direkt
          unter dem Kaufbereich, damit er nicht zwischen Beschreibung und
          Aufklappern untergeht. */
  function produktseiteHinweisen() {
    if (!cfg.aufSoloSeite || !cfg.produktseite) return;
    if (document.querySelector('.t12-solo--produktseite')) return;

    var anker = document.querySelector('form[action*="/cart/add"]');
    if (!anker) return;

    var ziel = anker.closest('.product-info, .product-form, [class*="product-info"]') || anker;
    ziel.parentNode.insertBefore(kasten(cfg.produktseite, 't12-solo--produktseite'),
                                 ziel.nextSibling);
  }

  function start() { ladeStand(); warenkorbSperren(); produktseiteHinweisen(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* Die Warenkorb-Schublade wird nachgeladen. Beobachten statt einmalig
     pruefen, sonst fehlt der Hinweis genau dort, wo er am meisten zaehlt. */
  new MutationObserver(function () { warenkorbSperren(); produktseiteHinweisen(); })
    .observe(document.body, { childList: true, subtree: true });
})();
